import { Navigation } from "../Navigation/Navigation";

export const Header = () => (
	<header className="header">
		<div className="header__logo">
			<h1 className="header__logo-name">ALISA V. MOLDAVANOVA</h1>
		</div>

		<Navigation />
	</header>
);
